module.exports = __webpack_public_path__ + "static/download-9-STEP-12ff91aae0a347d772a24f96d9a68e65.jpg";